/**
 * Copyright © 2026 Adnuntius AS.
 */
import * as _ from 'lodash';

const BAD_WORD_LIST = ['fuck', 'shit', 'piss', 'porn', 'tits', 'breast', 'cock', 'dick', 'pussy', 'cunt', 'gambling', 'gamble', 'bet', 'sex'];

interface CampaignCommonsController {
  maxHeight?: number;
  maxWidth?: number;
  [key: string]: any;
}

interface CreativeLayoutComponent {
  tag: string;
  type: string;
  name?: string;
}

interface CreativeAsset {
  id: string;
  cdnId?: string;
  width: number;
  height: number;
}

interface CreativeReviewItem {
  assets?: CreativeAsset[];
  components?: Array<{type: string; key: string; value: any}>;
  creative: {
    layoutParameters?: Record<string, any>;
    targeting?: any;
    vm?: any;
  };
  layout?: {
    layoutComponents?: CreativeLayoutComponent[];
  };
}

interface CampaignReviewItem {
  badWords?: string;
  creatives?: CreativeReviewItem[];
}

export interface CampaignCommonsApi {
  setUpComponents(params: string | string[]): void;
}

function flattenUserSegments(object: CreativeReviewItem['creative']): any[] {
  return _.flatten(_.map(_.get(object, ['targeting', 'userSegmentTargets']), function(us: any) {
    return us.userSegments;
  }));
}

export function campaignCommons(ctrl: CampaignCommonsController): CampaignCommonsApi {
  return {
    setUpComponents(params: string | string[]) {
      ctrl.maxHeight = 100;
      ctrl.maxWidth = 100;

      const collection = _.get(ctrl, params);
      if (!collection) {
        return;
      }
      _.forEach(_.isArray(collection) ? collection : [collection], function(item: CampaignReviewItem) {
        let badWords: string[] = [];
        _.forEach(item.creatives, function(creative: CreativeReviewItem) {
          creative.creative.vm = creative.creative.vm || {};
          creative.creative.vm.userSegments = flattenUserSegments(creative.creative);

          const layout = _.get(creative, ['layout']);
          const assets = _.get(creative, ['assets']);
          creative.components = [];
          _.forEach(_.get(creative, ['creative', 'layoutParameters']), function(val: any, key: string) {
            const lc = layout && _.find(layout.layoutComponents, function(layoutComponent: CreativeLayoutComponent) {
              return layoutComponent.tag === key;
            });
            if (!lc) {
              return;
            }
            const data = _.cloneDeep(val);
            if (lc.type === 'ASSET') {
              const asset = _.find(assets, function(a: CreativeAsset) {
                return a.id === val.id;
              });
              if (!asset) {
                return;
              }
              data.cdnId = asset.cdnId;
              data.width = asset.width;
              data.height = asset.height;
              const width = asset.width;
              const height = asset.height;
              const ratio = width > height ? ctrl.maxWidth / width : ctrl.maxHeight / height;
              data.style = 'zoom:(' + ratio + ');-moz-transform: scale(' + ratio + '); -moz-transform-origin: 0 0; -o-transform: scale(' + ratio + '); -o-transform-origin: 0 0; -webkit-transform: scale(' + ratio + '); -webkit-transform-origin: 0 0;';
            } else if (lc.type === 'TEXT' && _.isString(val)) {
              badWords = _.uniq(badWords.concat(_.filter(BAD_WORD_LIST, function(word) {
                return val.toLowerCase().indexOf(word) > -1;
              })));
            }
            creative.components.push({
              type: lc.type,
              key: lc.name || key,
              value: data
            });
          });
        });
        item.badWords = badWords.join(', ');
      });
    }
  };
}
